@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

/* stylelint-disable css-modules/no-global-scoped-selector */
:global(.blaze-toast-container:has(.persistent-toast-container)),
:global(.blaze-toast-container .persistent-toast-container) {
  z-index: map-get($z-index, popover) !important;
}
/* stylelint-enable css-modules/no-global-scoped-selector */

.root {
  display: flex;
  padding: 15px;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;

  border-radius: 10px;
  background: var(--dark-80);
  box-shadow: 0px 8px 22px 0px rgba(0, 0, 0, 0.14);
  @include blur(35px);

  min-width: 400px;
  max-width: 500px;
  width: fit-content;

  @include for-phone-only {
    width: 90%;
    min-width: 90%;
    max-width: 90%;
    border-radius: 20px;

    margin: 0 auto;
  }

  &.isRightRailOpen {
    margin-right: var(--right-rail-content-width);
  }

  :global(.blaze-toast-container) {
    z-index: 999;
  }
}

.header {
  display: flex;
  gap: 5px;
  align-items: center;
  max-width: 100%;

  @include for-phone-only {
    width: 100%;
    min-width: 0;
  }

  .closeButton {
    position: absolute;
    right: 15px;
    top: 15px;

    button {
      color: var(--light-100);
    }
  }

  .icon {
    color: var(--light-100);
    display: flex;
    align-items: center;
    height: 32px;
    width: 32px;

    @include for-phone-only {
      flex-shrink: 0;
    }
  }

  .title {
    flex-grow: 1;
    padding-right: 45px;

    @include for-desktop-only {
      @include line-clamp(1);
    }

    @include for-phone-only {
      padding-right: 0px;
      min-width: 0;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
}

.actions {
  display: flex;
  justify-content: space-between;
  width: 100%;

  @include for-phone-only {
    flex-direction: column;
    gap: 10px;
  }

  .secondaryAction {
    button {
      color: var(--light-100);
      background: var(--light-7, rgba(255, 255, 255, 0.07));
    }
  }

  .primaryAction {
    margin-left: auto;
    background-color: var(--light-80);
    border-radius: 6px;

    @include for-phone-only {
      margin-left: 0;
    }
  }
}

.checkboxContainer {
  cursor: pointer;
  width: 100%;
}

.checkboxLabel {
  flex: 1;
  user-select: none;
  color: var(--light-100);
}
